/* ==========================================================================
 * bs-winkelwagen.js - palletblok en overzicht op de winkelwagenpagina
 * --------------------------------------------------------------------------
 * Hoort bij sections/bs-winkelwagen-pallet.liquid, main-cart-items.liquid en
 * main-cart-footer.liquid. Refresh doet het echte werk (aantallen wijzigen,
 * verwijderen, secties opnieuw tekenen via cart.js); dit bestand leest daarna
 * wat er getekend is en vult het palletblok en het overzicht aan.
 *
 * GELD: hier wordt geen eigen rekenregel gebruikt.
 *   - pallets en percentage: BBKern.palletStand
 *   - rollen per diameter:   BBWinkel.rollenPerDiameter (de pure kern van
 *                            BBWinkel.rollenInWinkelwagen; die gebruiken we
 *                            als de winkelwagen niet op de pagina staat)
 *   - kortingsbedrag:        BBKern.geschatteKortingCenten, ALLEEN als
 *                            settings.bs_palletkorting_actief aan staat en
 *                            Shopify zelf nog geen korting in de wagen heeft.
 *                            Heeft Shopify wel een korting, dan staat die in
 *                            de Liquid en telt dat bedrag.
 *   - bedragen en btw:       BSBtw.prijsHtml / BSBtw.exclCenten
 * ========================================================================== */
(function (global) {
  'use strict';

  /* Dit bestand wordt door twee secties op de winkelwagenpagina ingeladen
     (bs-winkelwagen-pallet en main-cart-items), zodat de stelknoppen blijven
     werken als een van de twee uit het sjabloon wordt gehaald. De browser
     haalt het bestand een keer op maar voert het twee keer uit; zonder deze
     poort zou elke klik dan twee verzoeken sturen. Ook de thema-editor, die een
     sectie opnieuw opbouwt, komt hier langs. */
  if (global.BSWinkelwagen) { return; }

  var doc = global.document;

  /* Klantteksten uit window.BSTekst (snippets/bs-teksten.liquid, sleutels bs.* in de
     locale-bestanden). Ontbreekt een tekst, dan de Nederlandse terugval die hier
     in de code staat. {naam} in een tekst wordt ingevuld met waarden.naam. */
  function tk(sleutel, terug, waarden) {
    var bron = global.BSTekst;
    var s = (bron && typeof bron[sleutel] === 'string' && bron[sleutel] !== '' && bron[sleutel].indexOf('translation missing') !== 0) ? bron[sleutel] : terug;
    if (!waarden) { return s; }
    return String(s).replace(/\{(\w+)\}/g, function (heel, naam) {
      return Object.prototype.hasOwnProperty.call(waarden, naam) ? String(waarden[naam]) : heel;
    });
  }

  /* ---------- lezen ---------- */

  function leesJson(sel) {
    var lijst = doc.querySelectorAll(sel);
    var el = lijst.length ? lijst[lijst.length - 1] : null;
    if (!el) { return null; }
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function wagenVanPagina() { return leesJson('#main-cart-footer [data-bs-ww-cart]'); }

  /* ---------- opmaak ---------- */

  /* Een palletgetal op twee decimalen, half naar boven. De kleine marge vangt
     1,225 op dat als 1,2249999 uit de deling komt. */
  function tweeDec(x) { return Math.round((Number(x) + 0.000001) * 100) / 100; }

  function palletWoord(n) { return n >= 2 ? tk('pallets', 'pallets') : tk('pallet_een', 'pallet'); }

  function getal(n) {
    return (global.BBKern && global.BBKern.getal) ? global.BBKern.getal(n, 2) : String(n).replace('.', ',');
  }

  function rollenWoord(n) { return n === 1 ? tk('rol_een', '1 rol') : tk('rollen', '{aantal} rollen', { aantal: n }); }

  function prijs(centen, maat) {
    return global.BSBtw ? global.BSBtw.prijsHtml(centen, { maat: maat || 'klein' }) : '';
  }

  function exclCenten(centen) {
    return global.BSBtw ? global.BSBtw.exclCenten(centen) : Math.round(Number(centen) * 100 / 121);
  }

  /* Zelfde HTML als BSBtw.prijsHtml, maar met een ZELF MEEGEGEVEN excl.-bedrag.
     Nodig voor het totaal: dat excl.-bedrag is opgebouwd uit de afgeronde
     onderdelen (zie main-cart-footer, FUNCTIONEEL B2) en is dus niet altijd
     gelijk aan exclCenten(totaal). Het incl.-bedrag blijft precies dat van
     Shopify. */
  function prijsTwee(inclCenten, exclC, maat) {
    if (!global.BSBtw) { return ''; }
    var m = (maat === 'groot' || maat === 'klein') ? maat : 'normaal';
    return '<span class="bs-prijs bs-prijs--' + m + '">'
      + '<span class="bs-incl">' + global.BSBtw.bedrag(inclCenten) + '</span>'
      + '<span class="bs-excl">' + global.BSBtw.bedrag(exclC) + '</span></span>';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- de berekening (puur, zonder DOM, los te toetsen) ---------- */

  /**
   * @param {object} G      BBWinkel.leesGegevens(...): { producten, pallet, treden }
   * @param {object} wagen  { item_count, items:[{id,quantity}], items_subtotal_price,
   *                          items_subtotal_excl, total_price, total_discount,
   *                          kortingen:[{titel,centen}] }
   *                        items_subtotal_excl is de SOM van de per regel afgeronde
   *                        excl.-bedragen (main-cart-footer rekent hem uit). Ontbreekt
   *                        hij, dan wordt het subtotaal alsnog in een keer afgerond.
   * @param {object} opties { kortingActief, verzendCenten, gratisVanafCenten }
   */
  function bereken(G, wagen, opties) {
    var K = global.BBKern;
    var uit = { leeg: !wagen || !wagen.item_count, pallet: null, overzicht: null };
    if (uit.leeg || !G || !K) { return uit; }

    var rollen = global.BBWinkel.rollenPerDiameter(G.producten, wagen);
    var sleutels = Object.keys(G.pallet || {}).filter(function (d) { return G.pallet[d] > 0; });
    var heeftRollen = Object.keys(rollen).some(function (d) { return rollen[d] > 0; });

    var treden = G.treden || { een: 5, twee: 10 };
    var stand = null;
    if (sleutels.length && heeftRollen) {
      var G2 = { producten: G.producten, pallet: G.pallet, treden: treden, winkelwagen: rollen };
      stand = K.palletStand(G2, Number(sleutels[0]), { rollen: 0, centen: 0 });
    }

    /* Korting die Shopify al in de wagen heeft: dat bedrag telt. */
    var shopifyPallet = 0;
    (wagen.kortingen || []).forEach(function (k) {
      if (/pallet/i.test(k.titel || '')) { shopifyPallet += Number(k.centen) || 0; }
    });

    var schatting = 0;
    if (stand && stand.percentage > 0 && opties.kortingActief && !(wagen.total_discount > 0)) {
      schatting = K.geschatteKortingCenten(wagen.items_subtotal_price, stand.percentage);
    }

    if (stand) {
      var getoond = tweeDec(stand.deel);
      /* Het getoonde getal mag nooit een trede halen die de kern (nog) niet geeft. */
      if (stand.pallets < 1 && getoond >= 1) { getoond = 0.99; }
      if (stand.pallets === 1 && getoond >= 2) { getoond = 1.99; }

      var delen = sleutels.filter(function (d) { return rollen[d] > 0; }).map(function (d) {
        var een = {}; een[d] = rollen[d];
        return { diameter: Number(d), rollen: rollen[d], perPallet: G.pallet[d], deel: K.palletDeel(G.pallet, een) };
      });
      delen.sort(function (a, b) { return a.diameter - b.diameter; });

      var doel = stand.pallets < 1 ? 1 : (stand.pallets < 2 ? 2 : null);
      uit.pallet = {
        stand: stand,
        getoond: getoond,
        delen: delen,
        treden: treden,
        doel: doel,
        nogTotDoel: doel ? tweeDec(doel - getoond) : 0,
        doelPercentage: doel === 1 ? treden.een : (doel === 2 ? treden.twee : 0),
        kortingCenten: shopifyPallet > 0 ? shopifyPallet : schatting
      };
    }

    if (schatting > 0) {
      var naKorting = wagen.total_price - schatting;
      var verzending = naKorting >= opties.gratisVanafCenten ? 0 : opties.verzendCenten;
      var totaal = naKorting + verzending;
      /* De excl.-kolom moet optellen (FUNCTIONEEL B2): het totaal excl. is
         subtotaal min korting plus verzending, elk apart afgerond, en niet een
         eigen afronding van het totaal. Incl. blijft ongewijzigd. */
      var subExcl = (typeof wagen.items_subtotal_excl === 'number')
        ? wagen.items_subtotal_excl
        : exclCenten(wagen.items_subtotal_price);
      var excl = subExcl - exclCenten(schatting) + exclCenten(verzending);
      uit.overzicht = {
        percentage: stand.percentage,
        korting: schatting,
        verzending: verzending,
        totaal: totaal,
        excl: excl,
        btw: totaal - excl
      };
    }
    return uit;
  }

  /* ---------- tekenen ---------- */

  function zetHtml(root, naam, html) {
    var el = root.querySelector('[data-bs-ww="' + naam + '"]');
    if (el) { el.innerHTML = html; }
    return el;
  }

  function tekenPallet(blok, p) {
    if (!blok) { return; }
    if (!p) { blok.hidden = true; return; }
    blok.hidden = false;

    var st = p.stand;
    var n = getal(p.getoond) + ' ' + palletWoord(p.getoond);
    var titel;
    if (st.percentage > 0) {
      titel = p.kortingCenten > 0
        ? tk('ww_titel_actief', '{n}, {pct}% palletkorting actief', { n: n, pct: st.percentage })
        : tk('ww_titel_goed', '{n}, goed voor {pct}% palletkorting', { n: n, pct: st.percentage });
    } else {
      titel = tk('ww_titel_geen', '{n}, nog geen palletkorting', { n: n });
    }
    zetHtml(blok, 'titel', esc(titel));

    var badge = blok.querySelector('[data-bs-ww="badge"]');
    if (badge) {
      if (p.kortingCenten > 0) { badge.innerHTML = '&minus;&nbsp;' + prijs(p.kortingCenten, 'klein'); badge.hidden = false; }
      else { badge.hidden = true; badge.innerHTML = ''; }
    }

    /* balk: de schaal loopt van 0 tot 2 pallets */
    var spoor = '';
    var links = 0;
    p.delen.forEach(function (d, i) {
      var breed = Math.max(0, Math.min(100 - links, d.deel / 2 * 100));
      if (breed <= 0) { return; }
      spoor += '<i class="bs-ww-deel bs-ww-d' + d.diameter + (i ? ' bs-ww-deel--na' : '') + '" style="left:' + links.toFixed(2) + '%;width:' + breed.toFixed(2) + '%"></i>';
      links += breed;
    });
    zetHtml(blok, 'spoor', spoor);
    zetHtml(blok, 'merk1', tk('ww_merk1', '<b>1 pallet</b> &middot; {pct}%', { pct: p.treden.een }));
    zetHtml(blok, 'merk2', tk('ww_merk2', '<b>2 pallets</b> &middot; {pct}%', { pct: p.treden.twee }));
    var meter = blok.querySelector('.bs-ww-meter');
    if (meter) {
      meter.setAttribute('aria-label', tk('ww_meter_label', '{n} van 2 pallets', { n: getal(p.getoond) }));
    }

    /* optelling per diameter */
    var optel = '';
    p.delen.forEach(function (d, i) {
      if (i) { optel += '<span class="bs-ww-plus" aria-hidden="true">+</span>'; }
      optel += '<span class="bs-ww-deelpil"><i class="bs-ww-stip bs-ww-d' + d.diameter + '" aria-hidden="true"></i>'
        + tk('ww_optel', '&Oslash;{d}&nbsp;cm: {rollen} van {per_pallet} <b>{deel}</b>', { d: d.diameter, rollen: rollenWoord(d.rollen), per_pallet: d.perPallet, deel: getal(tweeDec(d.deel)) }) + '</span>';
    });
    if (p.delen.length > 1) {
      optel += '<span class="bs-ww-plus" aria-hidden="true">=</span><span class="bs-ww-deelpil"><b>' + esc(n) + '</b></span>';
    }
    zetHtml(blok, 'optel', optel);

    var nog = p.doel
      ? tk('ww_nog', 'Nog <b>{n}</b> tot {pct}% korting', { n: getal(p.nogTotDoel) + ' ' + palletWoord(p.nogTotDoel), pct: p.doelPercentage })
      : tk('ww_hoogste', 'Je zit op de hoogste palletkorting, <b>{pct}%</b>', { pct: p.treden.twee });
    zetHtml(blok, 'nog', nog);
  }

  function tekenOverzicht(o) {
    var root = doc.getElementById('main-cart-footer');
    if (!root || !o) { return; }
    var regel = root.querySelector('[data-bs-ww="korting-regel"]');
    if (regel) {
      regel.hidden = false;
      zetHtml(regel, 'korting-titel', tk('korting_titel', 'Palletkorting {pct}%', { pct: o.percentage }));
      zetHtml(regel, 'korting-bedrag', '&minus;&nbsp;' + prijs(o.korting, 'klein'));
    }
    var vz = root.querySelector('[data-bs-ww="verzending"]');
    if (vz) {
      vz.classList.toggle('bs-ww-gratis', o.verzending === 0);
      vz.innerHTML = o.verzending === 0 ? tk('gratis', 'Gratis') : prijs(o.verzending, 'klein');
    }
    zetHtml(root, 'totaal', prijsTwee(o.totaal, o.excl, 'groot'));
    zetHtml(root, 'btw', esc(global.BSBtw ? global.BSBtw.bedrag(o.btw) : ''));
    zetHtml(root, 'excl', esc(global.BSBtw ? global.BSBtw.bedrag(o.excl) : ''));
    zetHtml(root, 'incl', esc(global.BSBtw ? global.BSBtw.bedrag(o.totaal) : ''));
  }

  /* Pre-ordermeldingen per regel (main-cart-items rendert ze in Liquid, zodat ze
     er ook zonder JavaScript staan). Staat bs-preorder.js op de pagina, dan
     wordt de tekst daar opnieuw uit gehaald: snippets/bs-preorder.liquid blijft
     de enige plek waar de teksten staan. Geen eigen rekenwerk. */
  function tekenPo() {
    var P = global.BSPreorder;
    if (!P || typeof P.meldingHtml !== 'function') { return; }
    var lijst = doc.querySelectorAll('#main-cart-items [data-bs-ww-po]');
    for (var i = 0; i < lijst.length; i++) {
      var el = lijst[i];
      var d = el.dataset || {};
      var opties = { variantId: d.variantId, bron: 'Winkelwagen', maat: d.maat };
      if (d.gevraagd) { opties.gevraagd = Number(d.gevraagd); }
      if (d.tekort) { opties.tekort = Number(d.tekort); }
      if (d.voorraad) { opties.opVoorraad = Number(d.voorraad); }
      var html = P.meldingHtml(d.soort || 'wagenmax', opties);
      if (html) { el.innerHTML = html; }
    }
  }

  function tekenSub(wagen) {
    var sub = doc.querySelector('[data-bs-ww="sub"]');
    var verder = doc.querySelector('.bs-ww-verder');
    var leeg = !wagen || !wagen.item_count;
    if (verder) { verder.hidden = leeg; }
    if (!sub) { return; }
    if (leeg) { sub.hidden = true; return; }
    var a = wagen.item_count;
    var m = (wagen.items || []).length;
    sub.textContent = a + ' ' + (a === 1 ? tk('ww_artikel_een', 'artikel') : tk('ww_artikelen', 'artikelen')) + ' ' + tk('ww_in', 'in') + ' ' + m + ' ' + (m === 1 ? tk('ww_maat_een', 'maat') : tk('ww_maten', 'maten'));
    sub.hidden = false;
  }

  function opties() {
    var el = doc.querySelector('#main-cart-footer [data-bs-ww-instellingen]');
    var ds = el ? el.dataset : {};
    var blok = doc.querySelector('[data-bs-ww-pallet]');
    return {
      kortingActief: (blok && blok.getAttribute('data-korting-actief') === 'true') || ds.kortingActief === 'true',
      verzendCenten: Number(ds.verzendCenten || 499),
      gratisVanafCenten: Number(ds.gratisVanafCenten || 5000)
    };
  }

  function teken(wagen) {
    if (!global.BBWinkel || !global.BBKern) { return; }
    var G = global.BBWinkel.leesGegevens('bs-ww-rekendata');
    var w = wagen || wagenVanPagina();
    if (!w) {
      /* Geen winkelwagen op de pagina (bijvoorbeeld een aangepast sjabloon):
         haal hem op zoals de keuzehulp dat doet. */
      global.BBWinkel.winkelwagenLezen().then(function (cart) {
        teken({
          item_count: cart.item_count,
          items: (cart.items || []).map(function (i) { return { id: i.id, quantity: i.quantity }; }),
          items_subtotal_price: cart.items_subtotal_price,
          /* zelfde optelling als main-cart-footer: per regel afronden, dan optellen */
          items_subtotal_excl: (cart.items || []).reduce(function (som, i) {
            return som + exclCenten(i.final_line_price);
          }, 0),
          total_price: cart.total_price,
          total_discount: cart.total_discount,
          kortingen: (cart.cart_level_discount_applications || []).map(function (k) {
            return { titel: k.title, centen: k.total_allocated_amount };
          })
        });
      }).catch(function () {});
      return;
    }
    var uit = bereken(G, w, opties());
    tekenSub(w);
    tekenPallet(doc.querySelector('[data-bs-ww-pallet]'), uit.leeg ? null : uit.pallet);
    tekenOverzicht(uit.overzicht);
    tekenPo();
  }

  /* Na een wijziging die NIET via de rijen van de winkelwagen liep (bijvoorbeeld
     BBWinkel.meldWijziging): de twee secties zelf opnieuw ophalen. */
  function verversSecties() {
    var items = doc.getElementById('main-cart-items');
    var voet = doc.getElementById('main-cart-footer');
    if (!items || !voet) { teken(); return; }
    var ids = [items.dataset.id, voet.dataset.id];
    var url = global.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (secties) {
        [[items, ids[0]], [voet, ids[1]]].forEach(function (paar) {
          var html = secties[paar[1]];
          if (!html) { return; }
          var nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents');
          var oud = paar[0].querySelector('.js-contents');
          if (nieuw && oud) { oud.innerHTML = nieuw.innerHTML; }
        });
        var w = wagenVanPagina();
        var leeg = !w || !w.item_count;
        var ci = doc.querySelector('cart-items');
        if (ci) { ci.classList.toggle('is-empty', leeg); }
        voet.classList.toggle('is-empty', leeg);
        teken();
      })
      .catch(function () { teken(); });
  }

  /* ----------------------------------------------------------------------
   * DE GRENS VAN 50
   * ----------------------------------------------------------------------
   * Gemeten 16-09 op het werkthema met echte verzoeken (eerst variant
   * 59182714945861, daarna 59182714814789 met 146 op voorraad; meetbestanden in
   * nacht-16-09/mobiel/fix-F2 en in de meetmap van de fixronde). De grens hangt
   * af van het LOKET en van de VORM van het verzoek, en dat is makkelijk mis te
   * lezen:
   *
   *   1. /cart/add.js met { items: [{ id, quantity: 120 }] }
   *      -> 422 "Er zijn slechts 50 artikelen aan je winkelwagen toegevoegd
   *         vanwege beschikbaarheid" en de regel staat op 50. Nog een verzoek
   *         geeft 422 "De maximale hoeveelheid van dit artikel zit al in je
   *         winkelwagen" en verandert niets. Deze vorm komt dus nooit boven 50.
   *   2. /cart/add.js met { id, quantity: 120 }  (de enkelvoudige vorm, die
   *      bs-preorder.js en de productpagina gebruiken)
   *      -> 200, de regel staat op 120. Nog eens 120 -> 240. GEEN grens.
   *      Ook na een geweigerd items[]-verzoek komt deze vorm er nog boven.
   *   3. /cart/change.js met { line, quantity } of { id: <regelsleutel> } boven
   *      de 50 -> 422 en de regel wordt op 50 GEZET, wat er ook stond. Van 240
   *      naar 300 vragen laat er 50 over; van 58 naar 57 ook. Bij meerdere
   *      regels raakt het ALLE regels boven de 50, niet alleen de gevraagde.
   *      Omlaag naar 50 of lager mag wel (120 -> 3 gaat goed).
   *   4. /cart/update.js met { updates: { <variant-id of regelsleutel>: n } }
   *      -> 200 en de regel wordt precies n. Gemeten: 3 -> 120, 58 -> 57,
   *      73 en 1 in een verzoek. GEEN grens van 50, en het antwoord kan met
   *      sections/sections_url dezelfde secties meerenderen als change.js.
   *      LET OP: update.js controleert de VOORRAAD niet (200 van een maat met
   *      91 op voorraad werd aangenomen). De voorraadgrens staat daarom als
   *      max op het invoerveld in main-cart-items.liquid.
   *
   * Gevolg voor deze pagina: de stelknoppen gaan via update.js zodra er meer
   * dan 50 gevraagd wordt (punt 4), nooit via change.js (punt 3). Eerder stond
   * er max="50" op het invoerveld; daardoor klemde stepDown() een regel van 58
   * bij een tik op min eerst naar 50 en verloor de klant 8 rollen zonder
   * melding (bevinding K1). Die grens is weg; de plus- en minknop worden hier
   * zelf afgehandeld zodat stepUp/stepDown nooit meer kunnen klemmen.
   * Zelf toevoegen gaat via de enkelvoudige vorm (punt 2), net als de rest van
   * het thema. De lus knipt in blokken van 50 en stopt zodra een verzoek niets
   * meer toevoegt, en meldt eerlijk hoeveel er echt in is gekomen.
   * -------------------------------------------------------------------- */

  var STAP = 50;

  function wortel() {
    if (global.BBWinkel && typeof global.BBWinkel.wortel === 'function') { return global.BBWinkel.wortel(); }
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  }

  function wagenLezen() {
    if (global.BBWinkel && typeof global.BBWinkel.winkelwagenLezen === 'function') {
      return global.BBWinkel.winkelwagenLezen();
    }
    return fetch(wortel() + 'cart.js', {
      method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (a) { return a.json(); });
  }

  function aantalInWagen(wagen, variantId) {
    var id = String(variantId);
    var n = 0;
    ((wagen && wagen.items) || []).forEach(function (r) {
      if (String(r.variant_id || r.id) === id) { n += Number(r.quantity) || 0; }
    });
    return n;
  }

  /* Reservepad zolang window.BSPreorder.voegToe er nog niet is. Gebruikt de
     ENKELVOUDIGE vorm { id, quantity } (punt 2 hierboven); de items[]-vorm zou
     stilletjes op 50 blijven steken en dan belooft de knop meer dan hij levert.
     @returns {Promise<{ gevraagd, toegevoegd, wagen, fout }>} */
  function eigenVoegToe(variantId, aantal) {
    var id = Number(variantId);
    var gevraagd = Math.max(0, Math.floor(Number(aantal) || 0));
    var rest = gevraagd;
    var toegevoegd = 0;

    function ronde(wagenVoor) {
      if (rest <= 0) { return Promise.resolve(wagenVoor); }
      var had = aantalInWagen(wagenVoor, id);
      var blok = Math.min(rest, STAP);
      return fetch(wortel() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: id, quantity: blok })
      })
        /* Ook bij een 422 staat er vaak al iets in de wagen. Daarom telt niet het
           antwoord maar wat er daarna echt in de winkelwagen ligt. */
        .then(function () { return wagenLezen(); })
        .then(function (wagenNa) {
          var erbij = aantalInWagen(wagenNa, id) - had;
          if (erbij <= 0) { return wagenNa; }
          toegevoegd += erbij;
          rest -= erbij;
          return ronde(wagenNa);
        });
    }

    return wagenLezen().then(ronde).then(function (wagen) {
      return { gevraagd: gevraagd, toegevoegd: toegevoegd, wagen: wagen, fout: null };
    });
  }

  /* bs-preorder.js is uitgesteld en staat verderop in de pagina; bij een klik
     vlak na het laden kan BSPreorder er dus nog niet zijn. Even wachten, en
     anders het reservepad. */
  function wachtOpPreorder(maxMs, naam) {
    var sleutel = naam || 'meldingHtml';
    var eind = Date.now() + (Number(maxMs) || 0);
    return new Promise(function (klaar) {
      (function kijk() {
        var P = global.BSPreorder;
        if (P && typeof P[sleutel] === 'function') { klaar(P); return; }
        if (Date.now() >= eind) { klaar(P || null); return; }
        global.setTimeout(kijk, 60);
      }());
    });
  }

  /**
   * Een maat in de winkelwagen leggen en eerlijk terugmelden wat er echt in ligt.
   * Eerste keus is BSPreorder.voegToe (pre-order-contract): die neemt een LIJST
   * regels en lost altijd op, met { gelukt, toegevoegd, tekort, fout, wagen }.
   * Staat die er nog niet, dan doet eigenVoegToe hetzelfde werk.
   *
   * @returns {Promise<{ gevraagd, toegevoegd, wagen, fout }>}
   */
  function zetInWagen(variantId, aantal) {
    var gevraagd = Math.max(0, Math.floor(Number(aantal) || 0));
    return wachtOpPreorder(1500, 'voegToe').then(function (P) {
      if (P && typeof P.voegToe === 'function') {
        return Promise.resolve(P.voegToe([{ id: variantId, quantity: gevraagd }])).then(function (u) {
          var erbij = u && u.toegevoegd ? Number(u.toegevoegd[String(variantId)]) || 0 : 0;
          return { gevraagd: gevraagd, toegevoegd: erbij, wagen: (u && u.wagen) || null, fout: (u && u.fout) || null };
        });
      }
      return eigenVoegToe(variantId, gevraagd);
    });
  }

  /* De knop "{X} in winkelwagen" uit melding M2 van het pre-ordercomponent.
     Het contract (nacht-16-09/pre-order-contract.md, hoofdstuk 2) zegt dat de
     aanroeper die zelf afhandelt; op de winkelwagenpagina is dat dit bestand. */
  function aanKnopWinkelwagen() {
    doc.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest ? e.target.closest('[data-bs-po-actie="winkelwagen"]') : null;
      if (!knop || !doc.getElementById('main-cart-items')) { return; }
      if (!knop.closest('#main-cart-items') && !knop.closest('[data-bs-ww-pallet]')) { return; }
      e.preventDefault();
      if (knop.disabled) { return; }

      var id = knop.getAttribute('data-variant-id');
      var n = parseInt(knop.getAttribute('data-aantal'), 10) || 1;
      if (!id) { return; }

      var oud = knop.textContent;
      knop.disabled = true;
      knop.textContent = tk('bezig_toevoegen', 'Bezig met toevoegen');

      zetInWagen(id, n)
        .then(function (u) {
          if (u && u.fout) { throw new Error(u.fout.bericht || 'toevoegen mislukt'); }
          return (u && u.wagen) ? u.wagen : wagenLezen();
        })
        .then(function (wagen) {
          if (global.BBWinkel && typeof global.BBWinkel.meldWijziging === 'function') {
            global.BBWinkel.meldWijziging(wagen);   /* vuurt cart:refresh -> verversSecties */
          } else {
            verversSecties();
          }
        })
        .catch(function () {
          knop.disabled = false;
          knop.textContent = oud;
          var fout = doc.getElementById('cart-errors');
          if (fout) { fout.textContent = tk('ww_toevoegen_mislukt', 'Het toevoegen lukte niet. Probeer het nog een keer.'); }
        });
    });
  }

  /* ----------------------------------------------------------------------
   * AANTAL WIJZIGEN OP DE WINKELWAGENPAGINA
   * ----------------------------------------------------------------------
   * Drie dingen worden hier overgenomen van het Refresh-thema:
   *
   *  a. de plus- en minknop. quantity-input (global.js) gebruikt stepUp() en
   *     stepDown(), en de HTML-norm laat stepDown() een waarde BOVEN max eerst
   *     naar max klemmen. Met max="50" op een regel van 58 werd een tik op min
   *     dus 50 in plaats van 57. Hier wordt gewoon waarde +1 of -1 gerekend, met
   *     alleen de ondergrens en de echte bovengrens uit het veld.
   *
   *  b. het versturen. cart.js gebruikt /cart/change.js en dat loket is voor
   *     deze winkel onbruikbaar. GEMETEN 16-09, winkelwagen met 58x 17910 en
   *     5x 17908:
   *         POST /cart/change.js { line: 1, quantity: 4 }   (regel 17908)
   *         -> 200, GEEN foutmelding, en de ANDERE regel ging van 58 naar 50.
   *     change.js toetst dus bij ELK verzoek de hele winkelwagen opnieuw tegen
   *     zijn grens van 50 en kapt stilletjes af, ook regels waar de klant niet
   *     aan zat. Een winkelwagen met een pallet erin (48 tot 60 rollen per maat)
   *     mag change.js daarom nooit meer zien. Alles gaat naar /cart/update.js:
   *     die zet precies het gevraagde aantal, laat andere regels met rust
   *     (gemeten: 58 bleef 58) en kan met sections/sections_url dezelfde secties
   *     meerenderen, zodat het scherm net zo wordt bijgewerkt als cart.js doet.
   *
   *  c. de verwijderknop, om dezelfde reden: cart-remove-button in cart.js loopt
   *     ook via change.js.
   *
   * Belofte aan de klant: de winkelwagen bevat na afloop precies wat het scherm
   * toont, of er staat een melding in het foutvak van de regel.
   * -------------------------------------------------------------------- */

  var bezig = false;
  var laatsteKnop = null;

  function regelVan(el) { return (el && el.closest) ? el.closest('.cart-item') : null; }

  function foutTekst(regel, tekst) {
    var vak = regel ? regel.querySelector('.cart-item__error-text') : null;
    if (vak) { vak.textContent = tekst || ''; }
  }

  /* De echte bovengrens van een regel: een quantity_rule van Shopify of de
     voorraad van een gevolgde maat. Staat er geen max, dan is er geen grens. */
  function echteMax(input) {
    var m = parseInt(input.getAttribute('max'), 10);
    return isNaN(m) ? null : m;
  }

  /* De ondergrens: het invoerveld staat 0 toe (verwijderen via de prullenbak),
     maar Shopify's quantity_rule.min staat in data-min. Onder die grens hoort de
     klant een melding te krijgen in plaats van een stille weigering. */
  function echteMin(input) {
    var m = parseInt(input.dataset ? input.dataset.min : '', 10);
    if (isNaN(m) || m < 1) { return 1; }
    return m;
  }

  function maxMelding(input) {
    var max = echteMax(input);
    if (max === null) { return ''; }
    if (input.getAttribute('data-bs-max-bron') === 'voorraad') {
      return tk('ww_max_voorraad', 'Hiervan hebben we er nog {aantal} op voorraad. Meer nodig? Vraag een pre-order aan.', { aantal: max });
    }
    return tk('ww_max', 'Van dit artikel kun je er maximaal {aantal} bestellen.', { aantal: max });
  }

  function minMelding(input) {
    return tk('ww_min', 'Van dit artikel kun je er minimaal {aantal} bestellen. Gebruik het prullenbakje om de regel te verwijderen.', { aantal: echteMin(input) });
  }

  /* Zelfde toggles als quantity-input.validateQtyRules, want die luisteraar
     slaan we over zodra we de knop zelf afhandelen. */
  function knoppenBij(input) {
    var wrap = input.closest ? input.closest('quantity-input') : null;
    if (!wrap) { return; }
    var v = parseInt(input.value, 10);
    var min = parseInt(input.min, 10);
    var max = echteMax(input);
    var knopMin = wrap.querySelector('.quantity__button[name="minus"]');
    var knopPlus = wrap.querySelector('.quantity__button[name="plus"]');
    if (knopMin && !isNaN(min)) { knopMin.classList.toggle('disabled', v <= min); }
    if (knopPlus && max !== null) { knopPlus.classList.toggle('disabled', v >= max); }
  }

  /* Dezelfde vier secties die cart.js meerendert, in dezelfde volgorde. */
  function sectieLijst() {
    var items = doc.getElementById('main-cart-items');
    var voet = doc.getElementById('main-cart-footer');
    var lijst = [];
    if (items) { lijst.push({ id: 'main-cart-items', sectie: items.dataset.id, kies: '.js-contents' }); }
    lijst.push({ id: 'cart-icon-bubble', sectie: 'cart-icon-bubble', kies: '.shopify-section' });
    lijst.push({ id: 'cart-live-region-text', sectie: 'cart-live-region-text', kies: '.shopify-section' });
    if (voet) { lijst.push({ id: 'main-cart-footer', sectie: voet.dataset.id, kies: '.js-contents' }); }
    return lijst;
  }

  function tekenSecties(lijst, bron) {
    lijst.forEach(function (s) {
      var html = bron ? bron[s.sectie] : null;
      var houder = doc.getElementById(s.id);
      if (!html || !houder) { return; }
      var doel = houder.querySelector(s.kies) || houder;
      var nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector(s.kies);
      if (nieuw) { doel.innerHTML = nieuw.innerHTML; }
    });
  }

  function slot(index, aan) {
    var items = doc.getElementById('main-cart-items');
    if (items) { items.classList.toggle('cart__items--disabled', !!aan); }
    var draaiers = doc.querySelectorAll('#CartItem-' + index + ' .loading__spinner');
    for (var i = 0; i < draaiers.length; i++) { draaiers[i].classList.toggle('hidden', !aan); }
  }

  /**
   * Een regel op een nieuw aantal zetten via /cart/update.js. Lost altijd op.
   * @returns {Promise<{gelukt:boolean, aantal:number}>} aantal = wat er echt ligt
   */
  function zetRegel(input, gevraagd, knopNaam) {
    var regel = regelVan(input);
    var index = input.dataset.index;
    var sleutel = input.dataset.quantityLineKey || input.dataset.quantityVariantId;
    var oud = input.getAttribute('value');
    var lijst = sectieLijst();
    var updates = {};
    updates[String(sleutel)] = gevraagd;

    bezig = true;
    foutTekst(regel, '');
    slot(index, true);
    if (doc.activeElement && doc.activeElement.blur) { doc.activeElement.blur(); }

    return fetch(wortel() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: updates,
        sections: lijst.map(function (s) { return s.sectie; }),
        sections_url: global.location.pathname
      })
    })
      .then(function (a) {
        return a.json().catch(function () { return null; }).then(function (j) { return { status: a.status, wagen: j }; });
      })
      .then(function (a) {
        if (a.status !== 200 || !a.wagen || typeof a.wagen.item_count !== 'number') {
          throw new Error((a.wagen && (a.wagen.description || a.wagen.message)) || 'update mislukt');
        }
        var wagen = a.wagen;
        var echt = 0;
        (wagen.items || []).forEach(function (r) {
          if (String(r.key) === String(sleutel) || String(r.id) === String(sleutel)) { echt += Number(r.quantity) || 0; }
        });

        tekenSecties(lijst, wagen.sections);

        var ci = doc.querySelector('cart-items');
        var voet = doc.getElementById('main-cart-footer');
        if (ci) { ci.classList.toggle('is-empty', wagen.item_count === 0); }
        if (voet) { voet.classList.toggle('is-empty', wagen.item_count === 0); }

        /* Wat er echt ligt wijkt af van wat gevraagd is: dat moet de klant zien. */
        if (echt !== gevraagd) {
          var versRegel = doc.getElementById('CartItem-' + index);
          foutTekst(versRegel, global.cartStrings && global.cartStrings.quantityError
            ? global.cartStrings.quantityError.replace('[quantity]', echt)
            : tk('ww_nu_in_wagen', 'Er liggen er nu {aantal} in je winkelwagen.', { aantal: echt }));
        }

        if (typeof global.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { // eslint-disable-line no-undef
          global.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: wagen }); // eslint-disable-line no-undef
        } else {
          teken();
        }

        var terug = doc.getElementById('CartItem-' + index);
        var doel = (terug && knopNaam) ? terug.querySelector('[name="' + knopNaam + '"]') : null;
        if (doel && doel.focus) { doel.focus(); }

        return { gelukt: echt === gevraagd, aantal: echt };
      })
      .catch(function () {
        /* Niets veranderd, of niet te zeggen wat er veranderd is: het scherm
           terug naar wat er stond en eerlijk melden. */
        if (input && input.isConnected !== false) {
          input.value = oud;
          knoppenBij(input);
        }
        foutTekst(regelVan(input) || doc.getElementById('CartItem-' + index),
          tk('ww_aantal_mislukt', 'Het aantal is niet aangepast. Probeer het nog een keer.'));
        return { gelukt: false, aantal: parseInt(oud, 10) || 0 };
      })
      .then(function (uit) {
        slot(index, false);
        bezig = false;
        return uit;
      });
  }

  /* Het veld terug naar het aantal dat er echt ligt, met een melding erbij. */
  function weiger(input, tekst) {
    input.value = input.getAttribute('value');
    if (input.setCustomValidity) { input.setCustomValidity(''); }
    knoppenBij(input);
    foutTekst(regelVan(input), tekst);
  }

  function aanAantal() {
    if (!doc.getElementById('main-cart-items')) { return; }

    /* a. plus en min: zelf rekenen, nooit stepUp()/stepDown() laten klemmen. */
    doc.addEventListener('click', function (e) {
      var knop = (e.target && e.target.closest) ? e.target.closest('.quantity__button') : null;
      if (!knop || !knop.closest('#main-cart-items')) { return; }
      var wrap = knop.closest('quantity-input');
      var input = wrap ? wrap.querySelector('.quantity__input') : null;
      if (!input) { return; }

      e.preventDefault();
      e.stopPropagation();                 /* quantity-input in global.js overslaan */
      if (bezig || knop.disabled || input.disabled) { return; }

      var nu = parseInt(input.value, 10);
      if (isNaN(nu)) { nu = parseInt(input.getAttribute('value'), 10) || 0; }
      var max = echteMax(input);
      var min = echteMin(input);
      var plus = knop.name === 'plus';

      if (plus && max !== null && nu >= max) { foutTekst(regelVan(input), maxMelding(input)); return; }
      if (!plus && nu <= min) { foutTekst(regelVan(input), minMelding(input)); return; }

      laatsteKnop = knop.name;
      input.value = String(plus ? nu + 1 : nu - 1);
      knoppenBij(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    /* b. het versturen. cart.js mag dit NOOIT zien: change.js kapt regels boven
       de 50 af, ook regels waar de klant niet aan zat. */
    doc.addEventListener('change', function (e) {
      var input = (e.target && e.target.closest) ? e.target.closest('.quantity__input') : null;
      if (!input || !input.closest('#main-cart-items')) { return; }
      e.stopPropagation();

      var knopNaam = laatsteKnop;
      laatsteKnop = null;
      if (bezig) { return; }

      var gevraagd = parseInt(input.value, 10);
      var max = echteMax(input);
      var min = echteMin(input);
      var stap = parseInt(input.step, 10);

      if (isNaN(gevraagd)) { weiger(input, ''); return; }        /* leeg of onleesbaar veld */
      if (gevraagd < min) { weiger(input, minMelding(input)); return; }
      if (max !== null && gevraagd > max) { weiger(input, maxMelding(input)); return; }
      if (!isNaN(stap) && stap > 1 && gevraagd % stap !== 0) {
        weiger(input, tk('ww_stap', 'Dit artikel gaat per {aantal} stuks.', { aantal: stap })); return;
      }
      if (gevraagd === parseInt(input.getAttribute('value'), 10)) { foutTekst(regelVan(input), ''); return; }

      zetRegel(input, gevraagd, knopNaam);
    }, true);

    /* c. verwijderen. cart-remove-button in cart.js loopt via change.js. */
    doc.addEventListener('click', function (e) {
      var weg = (e.target && e.target.closest) ? e.target.closest('cart-remove-button') : null;
      if (!weg || !weg.closest('#main-cart-items')) { return; }
      var input = doc.getElementById('Quantity-' + weg.dataset.index);
      if (!input) { return; }              /* geen veld gevonden: cart.js zijn gang laten gaan */
      e.preventDefault();
      e.stopPropagation();
      if (bezig) { return; }
      laatsteKnop = null;
      zetRegel(input, 0, null);
    }, true);
  }

  function start() {
    teken();
    aanKnopWinkelwagen();
    aanAantal();
    var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null; // eslint-disable-line no-undef
    if (typeof global.subscribe === 'function' && events && events.cartUpdate) {
      global.subscribe(events.cartUpdate, function (evt) {
        /* cart.js heeft de secties dan al vervangen, dus de wagen op de pagina is vers. */
        if (evt && evt.source === 'cart-items') { teken(); }
        else { verversSecties(); }
      });
    }
    doc.documentElement.addEventListener('cart:refresh', function () { verversSecties(); });
    doc.addEventListener('shopify:section:load', function () { teken(); });
    /* bs-preorder.js staat later in de pagina en is ook uitgesteld, dus bij de
       eerste teken() kan window.BSPreorder er nog niet zijn. Een tweede ronde
       zodra hij er wel is.
       Hier stond eerder readyState !== 'complete' met alleen een DOMContentLoaded-
       luisteraar. Bij een latere herstart (shopify:section:load, of dit bestand dat
       nog eens draait) is de leesstand al 'complete': die gebeurtenis kwam dan nooit
       meer en de tweede ronde bleef uit. Nu: alleen luisteren zolang de pagina nog
       laadt, anders meteen tekenen. De wachtlus erna vangt de uitgestelde scripts in
       elke leesstand op, ook in 'interactive' (dan is DOMContentLoaded nog niet
       geweest maar staat bs-preorder.js mogelijk nog in de rij). */
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', tekenPo); }
    else { tekenPo(); }
    wachtOpPreorder(4000).then(tekenPo);
    global.addEventListener('pageshow', function (e) { if (e.persisted) { verversSecties(); } });
  }

  global.BSWinkelwagen = {
    bereken: bereken,
    teken: teken,
    ververs: verversSecties,
    tweeDec: tweeDec,
    tekenPo: tekenPo,
    /* toevoegen met de grens van 50 per regel; gebruikt BSPreorder.voegToe zodra die er is */
    zetInWagen: zetInWagen,
    eigenVoegToe: eigenVoegToe,
    /* een winkelwagenregel op een aantal zetten via /cart/update.js (0 = weg) */
    zetRegel: zetRegel,
    stap: STAP
  };

  if (doc) {
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); }
    else { start(); }
  }
}(typeof window !== 'undefined' ? window : globalThis));
